import moment from 'moment';
import React, { FC } from 'react';
import { ReactComponent as SurgeIcon } from 'assets/icons/update-surge-modal-icon.svg';
import { ReactComponent as DeliverySettingsIcon } from 'assets/icons/delivery-settings.svg';
import { HistoryItemType } from './types';

export type HistoryIconColor = 'green' | 'blue';

type HistoryTabProps = {
  list: HistoryItemType;
  color: HistoryIconColor;
};

const HistoryTabItem: FC<HistoryTabProps> = ({ list, color }) => {
  const { created_at, general_surge_history_text, scheduled } = list;

  const formattedDate = moment(created_at).format('dddd, MMM DD');
  const time = moment(created_at).format('h:mm a');
  return (
    <div className='mb-6 last:mb-0'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-6'>
          <div
            className={`hidden sm:flex ${color}-surge-icon w-[45px] h-[45px] rounded-full justify-center items-center`}>
            {color == 'blue' && <SurgeIcon />}
            {color == 'green' && <DeliverySettingsIcon />}
          </div>
          <div className='text-xs space-y-1'>
            <div className='flex items-center gap-2 text-gray-4'>
              {formattedDate} <div className='bg-gray-2 min-w-[8px] w-2 h-2 rounded-full'></div>
              {time}
            </div>
            <p className='text-gray-6'>{general_surge_history_text}</p>
          </div>
        </div>

        <div
          className={`w-[12px] h-[12px] ${
            scheduled ? 'bg-red-5' : 'bg-gray-9'
          } rounded-full`}></div>
      </div>
    </div>
  );
};

export default HistoryTabItem;
